module.exports = __webpack_public_path__ + "images/stickers/pete-alert@2x.12e2047369f2209a11d8.png";